module.exports = __webpack_public_path__ + "static/media/Group1591.99149183.jpg";